import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@startupquickstart/frontend';
import type { ReactNode } from 'react';
import { sectionAnchorId, type ChallengeEditorSectionId } from '../sectionRegistry';

interface SectionCardProps {
  id: ChallengeEditorSectionId;
  title: string;
  description?: string;
  /** Optional header-right control (e.g. the voiceover Regenerate button). */
  action?: ReactNode;
  children: ReactNode;
}

/**
 * The standard editor section card: anchored for the nav/scrollspy, with the
 * shared bordered header band. Every section renders through this so the
 * cards match exactly.
 */
export function SectionCard({ id, title, description, action, children }: SectionCardProps) {
  return (
    <Card
      id={sectionAnchorId(id)}
      className="scroll-mt-6 rounded-xl border bg-card shadow-sm py-0 gap-0"
    >
      <CardHeader className="px-6 py-4 !pb-4 border-b">
        <div className="flex items-center justify-between gap-4">
          <div>
            <CardTitle>{title}</CardTitle>
            {description && <CardDescription>{description}</CardDescription>}
          </div>
          {action}
        </div>
      </CardHeader>
      <CardContent className="p-6 space-y-6">{children}</CardContent>
    </Card>
  );
}
